import React, {PureComponent} from 'react'
import SimpleModal from '../../../common/components/SimpleModal'
import {Provider} from 'react-redux'

import store from '../../store'

class ViewModal extends PureComponent {

    render() {
        return (
            <SimpleModal ProvidedProvider={Provider} store={store} {...this.props} >
                {this.props.children}
            </SimpleModal>
        )
    }

}

export default ViewModal


// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/simple-modal.es6